import React from 'react';
import { Input, Form } from 'antd';
import PropTypes from 'prop-types';
import './NomeProduto.scss';

const NomeProdutoField = (props) => {
  const {
    rules,
    name,
    label,
    value,
    edit,
  } = props;
  return (
    <Form.Item
      label={<span className="field-title-text">{label}</span>}
      name={name}
      rules={rules}
      initialValue={value || undefined}
    >
      <Input disabled={edit} style={{ width: '100%' }} />
    </Form.Item>
  );
};

NomeProdutoField.defaultProps = {};
NomeProdutoField.propTypes = {
  rules: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.bool,
  label: PropTypes.element.isRequired,
  edit: PropTypes.bool,
};

export default NomeProdutoField;
